import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { fetchItemmap, setNotifyDone } from '../data/actions'
import * as select from '../data/selectors'
import { Grid, Button, Icon } from 'semantic-ui-react'
import Notification from '../../../utilities/notificationUtils'
import { heightSet } from '../../../utilities/heightSet'
import { searchColumns } from '../data/model';
import { TableListDiv } from '../../../utilities/tableListDiv';

const ItemmapList = (props) => {
    const itemmap = useSelector(state => select.getFilteredItemmap(state))
    const [deleteItemmapId, setDeleteItemmapId] = useState(false);

    const [heights, setHeight] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchItemmap());
    }, [dispatch]);

    const callHeightFunc = () => {
        heightSet(setHeight)
    }

    useEffect(() => {
        callHeightFunc();
        window.addEventListener("resize", function () {
            callHeightFunc();
        }, false);
        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener("resize", callHeightFunc);
        };
    }, []);

    const itemmapAction = ({ object: obj }) => {
        return (
            <>
                <Link to={"/itemmap/edit/" + obj.id} title="Edit">
                    <Icon name="edit" color="blue" link />
                </Link>
                <span style={{ color: "#cfd8e3", margin: "0 6px" }}>|</span>
                <Link to={"/itemmap/clone/" + obj.id} title="Clone">
                    <Icon name="copy outline" color="teal" link />
                </Link>
            </>
        )
    }

    const redirectToAddItemMap = () => {
        props.history.push({ pathname: "/itemmap/create" })
    }

    return (
        <>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        Item Map
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Manage DMS to RealBooks item mapping.
                    </div>
                </div>
                <Button
                    onClick={redirectToAddItemMap}
                    type="button"
                    color="blue"
                    size="small"
                    icon
                    labelPosition="left"
                >
                    <Icon name="plus" />
                    Add Item
                </Button>
            </div>
            <div style={{ paddingTop: "10px" }}>
                <TableListDiv columns={searchColumns} data={itemmap} Actions={itemmapAction} setHeight={parseFloat(heights) - 180} getIndex={6} filterBoxNone={''} rightBox={''} centerBox={''} callHeightFunc={callHeightFunc} paddingShort={2} getWidth={'100%'} actionClass={"actionTdDR"} />
            </div>
            {
                deleteItemmapId ?
                    <Notification id={deleteItemmapId} notifySelector={select.getNotification} notifyDoneAction={setNotifyDone} type='delete' />
                    :
                    null
            }
        </>
    )
}

export default ItemmapList;
